import { atom } from 'jotai';
import { OperatorDrawerNavs } from '@ibk/shared-types';
const operatorDrawerVisibleAtom = atom(false);
const operatorDrawerAuthenticatedAtom = atom(false);
export const operatorDrawerModalPasswordAuthenticationVisibleAtom = atom(false);
export const operatorDrawerAtom = atom(get => get(operatorDrawerVisibleAtom) &&
    get(operatorDrawerAuthenticatedAtom) &&
    !get(operatorDrawerModalPasswordAuthenticationVisibleAtom), (get, set, visible) => {
    if (!visible) {
        set(operatorDrawerVisibleAtom, false);
        set(operatorDrawerAuthenticatedAtom, false);
        set(operatorDrawerModalPasswordAuthenticationVisibleAtom, false);
        return;
    }
    const isAuthenticated = get(operatorDrawerAuthenticatedAtom);
    if (!isAuthenticated) {
        set(operatorDrawerModalPasswordAuthenticationVisibleAtom, true);
    }
});
export const operatorDrawerAuthenticateAtom = atom(get => get(operatorDrawerAuthenticatedAtom), (_, set, visible) => {
    set(operatorDrawerAuthenticatedAtom, visible);
    if (!visible) {
        set(operatorDrawerVisibleAtom, false);
        return;
    }
    set(operatorDrawerVisibleAtom, true);
    set(operatorDrawerModalPasswordAuthenticationVisibleAtom, false);
});
const operatorInnerDrawerNavigationAtom = atom([
    {
        route: OperatorDrawerNavs.HOME,
    },
]);
export const operatorDrawerNavigationCleared = atom(false);
export const operatorDrawerNavigationAtom = atom(get => get(operatorInnerDrawerNavigationAtom).at(-1) ?? { route: OperatorDrawerNavs.HOME, params: undefined }, (get, set, route, params) => {
    if (route === 'clear') {
        set(operatorInnerDrawerNavigationAtom, [{ route: OperatorDrawerNavs.HOME, params: undefined }]);
        set(operatorDrawerNavigationCleared, true);
        return;
    }
    set(operatorDrawerNavigationCleared, false);
    if (route === 'goBack') {
        if (get(operatorInnerDrawerNavigationAtom).length >= 2) {
            set(operatorInnerDrawerNavigationAtom, get(operatorInnerDrawerNavigationAtom).slice(0, -1));
        }
        else {
            set(operatorInnerDrawerNavigationAtom, [{ route: OperatorDrawerNavs.HOME, params: undefined }]);
        }
        return;
    }
    if (params) {
        set(operatorInnerDrawerNavigationAtom, [...get(operatorInnerDrawerNavigationAtom), { route: route, params }]);
        return;
    }
    set(operatorInnerDrawerNavigationAtom, [...get(operatorInnerDrawerNavigationAtom), { route: route }]);
});
export const operatorDrawerErrorAtom = atom(undefined);
export const operatorDrawerSuccessAtom = atom(undefined);
